import React, { FC } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useExperimentFlag } from '../../../utils/useExperimentFlag';
import { BoostedPostsGrid } from '../BoostedPostsGrid/BoostedPostsGrid';
import { BusinessPostsGrid } from '../BusinessPostsGrid/BusinessPostsGrid';
import { DiscoveryPostsGrid } from '../DiscoveryPostsGrid/DiscoveryPostsGrid';
import { PostDetailsLocationState } from '../PostDetails';
import { PostsGridProps } from './types';

export const PostsGrid: FC<PostsGridProps> = (props) => {
    const locationState = useLocation().state as PostDetailsLocationState | null;
    const params = useParams();
    const postId = params.postId!;
    const withSimilarRecommendations =
        Number(useExperimentFlag('similar_posts_under_post_card')) === 1;

    if (locationState?.fromBusinessId) {
        return <BusinessPostsGrid fromBusinessId={locationState.fromBusinessId} {...props} />;
    }

    if (postId && !withSimilarRecommendations) {
        return <BoostedPostsGrid postId={postId} {...props} />;
    }

    return <DiscoveryPostsGrid postId={postId} dialogName={locationState?.dialogName} {...props} />;
};
